export default __webpack_public_path__ + "static/media/sector_4.a48e23fd.jpg";